module.exports = __webpack_public_path__ + "static-appopensalud/img/montero-aramburu.4ba8c6b.png";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/montero-aramburu.png
// module id = 1026
// module chunks = 116